module.exports = __webpack_public_path__ + "static/gq-acquisition-web-if-offers-banner-gemv-mobile-321fd501c9045964ea10f78a74916d79.png";